import React from "react";
import classNames from "classnames";
import styles from "./RedirectLink.module.scss";
import { RedirectLinkProps } from "./RedirectLinkProps";

const RedirectLink = ({ data }: RedirectLinkProps) => {
  return (
    <div className={classNames(styles.content)}>
      {data.label}
      {"  "}
      <a className={classNames(styles.redirectLink)} href={data.redirect.route}>
        {data.redirect.label}
      </a>
    </div>
  );
};

export default RedirectLink;
